import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { initializeFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";
// Your web app's Firebase configuration  *in production
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  // apiKey: "AIzaSyCTjkwPpPJ4ezLH2Al4W1v4lR7lhiGTGhs",
  // authDomain: "oranjemund-town-council-b69df.firebaseapp.com",
  // projectId: "oranjemund-town-council-b69df",
  // storageBucket: "oranjemund-town-council-b69df.firebasestorage.app",
  // messagingSenderId: "797536480394",
  // appId: "1:797536480394:web:44738b7ba58704c4c25173",
  // measurementId: "G-W3LEE5PMYG",

  // apiKey: "AIzaSyB00hqtzHHOH_3D3SMj9KhAGrG-gn4kmrs",
  // authDomain: "lots-pms.firebaseapp.com",
  // projectId: "lots-pms",
  // storageBucket: "lots-pms.appspot.com",
  // messagingSenderId: "507817531923",
  // appId: "1:507817531923:web:f6813ccf3db341eaa1fde6",
  // measurementId: "G-27F3J0Q8S7",

  // apiKey: "AIzaSyDasgXX3u3cLujb7rwGlJpqgXV2wwfmKS8",
  // authDomain: "nkurenkuru-town-council.firebaseapp.com",
  // projectId: "nkurenkuru-town-council",
  // storageBucket: "nkurenkuru-town-council.appspot.com",
  // messagingSenderId: "651659197779",
  // appId: "1:651659197779:web:122730299f6c30bbacf5a6",
  // measurementId: "G-N3BJ50MDSN",

  //Dev
  //  apiKey: "AIzaSyCUghyqzwalQojYCJgnovBxM3-YnEgVd2s",
  // authDomain: "nkurenkuru-36978.firebaseapp.com",
  // projectId: "nkurenkuru-36978",
  // storageBucket: "nkurenkuru-36978.firebasestorage.app",
  // messagingSenderId: "378590785803",
  // appId: "1:378590785803:web:ce211399e815b5901af20e"

  apiKey:
    process.env.REACT_APP_FIREBASE_API_KEY ||
    "AIzaSyDasgXX3u3cLujb7rwGlJpqgXV2wwfmKS8",
  authDomain:
    process.env.REACT_APP_FIREBASE_AUTH_DOMAIN ||
    "nkurenkuru-town-council.firebaseapp.com",
  projectId:
    process.env.REACT_APP_FIREBASE_PROJECT_ID || "nkurenkuru-town-council",
  storageBucket:
    process.env.REACT_APP_FIREBASE_STORAGE_BUCKET ||
    "nkurenkuru-town-council.appspot.com",
  messagingSenderId:
    process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "651659197779",
  appId:
    process.env.REACT_APP_FIREBASE_APP_ID ||
    "1:651659197779:web:122730299f6c30bbacf5a6",
  measurementId:
    process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-N3BJ50MDSN",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const appAuthWorker = initializeApp(firebaseConfig, "authWorker");

export const auth = getAuth(app);
export const authWorker = getAuth(appAuthWorker);

export const analytics = getAnalytics(app);
export const db = initializeFirestore(app, {
  experimentalForceLongPolling: true,
});

export const storage = getStorage(app);
export const functions = getFunctions(app);
